import { useAuthStore } from "@/stores/auth.store";

/**
 * Retourne les permissions effectives de l'utilisateur courant.
 * Le wildcard `*` (Super Admin) accorde tout.
 */
export function usePermissions(): {
	permissions: string[];
	has: (...required: string[]) => boolean;
	hasAny: (...candidates: string[]) => boolean;
	isSuperAdmin: boolean;
} {
	const permissions = useAuthStore((s) => s.user?.permissions ?? []);
	const isSuperAdmin = permissions.includes("*");

	return {
		permissions,
		isSuperAdmin,
		has: (...required) => {
			if (isSuperAdmin) return true;
			return required.every((r) => permissions.includes(r));
		},
		hasAny: (...candidates) => {
			if (isSuperAdmin) return true;
			return candidates.some((c) => permissions.includes(c));
		},
	};
}
